import log from 'loglevel';
import { PlayerEvent } from '../../PlayerEvents';
import { systemProbe } from '../../utils/util';
import EventEmitter from 'event-emitter';
import qs from 'qs';

const GSLB_LIVE_API = 'api/dispatch_play';
const GSLB_VOD_API = 'api/dispatch_replay';

/**
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */

/**
 * 抽象调度器， 子类实现直播调度以及回放调度
 *
 * @export
 * @class AbstractScheduler
 */
export default class AbstractScheduler {
  constructor() {
    EventEmitter(this);
    this.CLASS_NAME = this.constructor.name;
    this.xhr = null;
    this.player = null;
    this.option = null;
    this.is_live = '';
    this.vod_video_uri = '';
    this.type = '';
    this.browserType = systemProbe().browser;
    this.readySeted = false; //是否已经出发ready事件。防止重复出发。
  }

  destroy() {}

  fetch() {
    this.xhr = new XMLHttpRequest();
    let xhr = this.xhr;
    // IE, 无法赋值
    if (this.browserType !== 'ie') {
      xhr.responseType = 'json';
      xhr.timeout = 5000;
    }
    xhr.onerror = e => {
      this.player.emit2All(PlayerEvent.SCHEDULER_FAIL, { code: 1, message: '调度报错' });
      log.error('error', `fetch error. url: ${url}`);
      this.emit('error', {
        details: 'schedulerLoadError',
        type: 'error'
      });
    };

    xhr.ontimeout = e => {
      this.player.emit2All(PlayerEvent.SCHEDULER_FAIL, { code: 1, message: '调度超时' });
      log.info('error', `fetch timeout. code: ${e.code}`);
      this.emit('error', {
        details: 'schedulerFetchTimeout',
        type: 'error'
      });
    };

    xhr.onload = e => {
      // IE, 由于未赋值responseType为JSON，故手动解析
      let response = e.target.response;
      if (this.browserType === 'ie' && response && typeof response === 'string') {
        try {
          response = JSON.parse(response);
        } catch (error) {
          response = e.target.response;
        }
      }
      this.resolveData(response);
    };

    xhr.onloadend = e => this.__innerXHRDestroy();

    let url = this.buildGSLBRequestUrl();
    xhr.open('GET', url);
    xhr.send();
  }

  /**
   * 获取一个9位随机数
   *
   * @returns
   * @memberof VodScheduler
   */
  getRandom() {
    return ((Math.random() * 899999999) >> 0) + 100000000;
  }

  /**
   * 构造播放调度URL
   * @returns
   */
  buildGSLBRequestUrl() {
    let obj = {};
    obj.app_id = this.option['app_id'];
    obj.webinar_id = this.option['webinar_id'];
    obj.uid = this.option['uid'];
    obj.bu = this.option['bu'];
    obj.rand = this.getRandom();
    let gslb_server = this.option['gslb_server'];
    let url;

    // 区分直播调度和点播调度
    if(this.is_live) {
      // 接口地址： http://yapi.vhall.domain/project/56/interface/api/19761
      if(this.option['live_delay'].toString() === '1') {
        // 延播场景
        obj.is_delay_stream = 1;
        //强制忽略延迟，观看普通延迟直播流
        if(this.option['force_ignore_delay']) {
          obj.force_ignore_delay = 1;
        }
      }
      let queryString = qs.stringify(obj);
      url = `${gslb_server}/${GSLB_LIVE_API}?${queryString}`;
    } else {
      // 接口地址：http://yapi.vhall.domain/project/56/interface/api/42383
      if (this.option['app_custom_line'] === true) {
        obj.app_custom_line = 1;
      }
      obj.uri = this.vod_video_uri;
      let qualities = this.option['quality'] || ['same'];
      // 拼接的数据为 &quality=["same",360p",480p"]
      obj.quality = qualities.length === 0 ? '["same"]' : `["${qualities.join('","')}"]`;
      let queryString = qs.stringify(obj);
      url = `${gslb_server}/${GSLB_VOD_API}?${queryString}`;
    }
    log.info(`播放调度请求url: ${url}`);
    this.player.schedulerUrl = url;
    return url;
  }

  resolveData(data) {}

  __innerXHRDestroy() {
    if (!this.xhr) return;

    this.xhr.onerror = null;
    this.xhr.ontimeout = null;
    this.xhr.onload = null;
    this.xhr.onloadend = null;
    this.xhr = null;
  }
}
